var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreLoginProvisionalIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 60,
    viewBox: "0 0 59 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3641 47.1577C51.9927 40.0649 53.235 27.3168 46.1388 18.6841C39.0426 10.0513 26.2951 8.80287 17.6665 15.8957C9.03785 22.9884 7.79557 35.7365 14.8918 44.3693C21.988 53.0021 34.7355 54.2505 43.3641 47.1577Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3292 44.1006C49.9556 37.0044 51.1933 24.2554 44.0938 15.6249C36.9942 6.99436 24.2459 5.75049 15.6195 12.8466C6.99307 19.9428 5.75531 32.6917 12.8549 41.3223C19.9544 49.9528 32.7028 51.1967 41.3292 44.1006Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5137 49.0264C26.8264 49.0264 25.1281 48.8169 23.4495 48.3929C12.4727 45.62 5.79363 34.4346 8.5607 23.4579C9.90122 18.1403 13.2323 13.6645 17.9401 10.8541C22.648 8.04391 28.1694 7.2356 33.4869 8.579C44.4638 11.3518 51.1427 22.5373 48.3755 33.5139C47.035 38.8315 43.7039 43.3076 38.9961 46.1178C35.7743 48.0408 32.1713 49.0264 28.5137 49.0264ZM28.4237 8.54928C24.8734 8.54928 21.3769 9.50551 18.2497 11.3722C13.6801 14.1 10.447 18.4442 9.1459 23.6053C6.46005 34.2595 12.943 45.1165 23.5974 47.8077C28.7582 49.1109 34.1173 48.3274 38.6868 45.5998C43.2562 42.872 46.4894 38.5278 47.7904 33.3667C50.4764 22.7125 43.9936 11.8555 33.3391 9.16435C31.7101 8.7528 30.061 8.54928 28.4237 8.54928Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 26.5L28 34L37 26.5H19Z",
    fill: "#BE7800"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 17.5H22.7403C23.6545 18.1844 24.25 19.2726 24.25 20.5C24.25 22.5677 22.5677 24.25 20.5 24.25V34H35.5V20.5L32.5 17.5Z",
    fill: "#F0F0F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 24.249V33.999H22V23.9336C21.5403 24.1353 21.0333 24.249 20.5 24.249Z",
    fill: "#D2D2D2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 20.5L32.5 17.5V20.5H35.5Z",
    fill: "#D2D2D2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37 38.5H19V26.5L27.2526 33.3771C27.6996 33.7495 28.3004 33.7495 28.7474 33.3771L37 26.5V38.5Z",
    fill: "#FAB400"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19 26.5V38.5H20.5V27.7499L19 26.5Z",
    fill: "#DC9600"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5456 31.9531L19 38.4988H20.5L26.3635 32.6353L25.5456 31.9531Z",
    fill: "#BE7800"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6367 32.6353L35.5002 38.4988H37.0002L30.4546 31.9531L29.6367 32.6353Z",
    fill: "#BE7800"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.25 25H22.75V24.25H33.25V25Z",
    fill: "#D2D2D2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.25 26.5H22.75V25.75H33.25V26.5Z",
    fill: "#D2D2D2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 28H22.75V27.25H29.5V28Z",
    fill: "#D2D2D2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4996 21.25V20.5H24.2496C24.2496 20.7569 24.2233 21.0077 24.1738 21.25H26.4996Z",
    fill: "#FA6450"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4929 22.75C23.281 23.0312 23.0312 23.281 22.75 23.4929V23.5H33.25V22.75H23.4929Z",
    fill: "#D2D2D2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 23.5C22.1569 23.5 23.5 22.1569 23.5 20.5C23.5 18.8431 22.1569 17.5 20.5 17.5C18.8431 17.5 17.5 18.8431 17.5 20.5C17.5 22.1569 18.8431 23.5 20.5 23.5Z",
    fill: "#3CC8B4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 20.5C18.25 18.9704 19.3956 17.7107 20.875 17.5259C20.752 17.5105 20.6271 17.5 20.5 17.5C18.8432 17.5 17.5 18.8432 17.5 20.5C17.5 22.1568 18.8432 23.5 20.5 23.5C20.6271 23.5 20.752 23.4895 20.875 23.4741C19.3956 23.2892 18.25 22.0296 18.25 20.5Z",
    fill: "#1EAA96"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.375 19.75L20.125 22L18.625 20.5L19.375 19.75L20.125 20.5L21.625 19L22.375 19.75Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreLoginProvisionalIcon);
export default __webpack_public_path__ + "static/media/pre-login-provisional-icon.04f4ffce16692ce982e490176f709bc9.svg";
export { ForwardRef as ReactComponent };